import useEntity from "@web-src/features/app/hooks/useEntity";
import { getUserRoleFlags } from "@jugl-web/domain-resources/users/utils/getUserRoleFlags";

export const useUserRole = () => getUserRoleFlags(useEntity().entity?.role);
